import React from 'react'
import config from '@/config'

//Redux

// Route
import gckCodeRoutes from '@/features/GCKCodes/routes'
import SLARoutes from '@/features/SLAs/routes'
import applicationTypeRoutes from '@/features/applicationTypes/routes'
import configRoutes from '@/features/configs/routes'
import contributorGroupRoutes from '@/features/contributorGroups/routes'
import costCenterRoutes from '@/features/costCenters/routes'
import customerRoutes from '@/features/customers/routes'
import delegationRoutes from '@/features/delegations/routes'
import documentTemplateRoutes from '@/features/documentTemplates/routes'
import ruleRoutes from '@/features/rules/routes'
import { vendorAdminRoutes } from '@/features/vendors/routes'
import systemVariableRoutes, { hsCodeRoutes } from '@/features/systemVariables/routes'
import { adminUserRoutes } from '@/features/users/routes'
import tableProfileRoutes from '@/features/tableProfiles/routes'
import frameAgreementRoutes from '@/features/frameAgreements/routes'
import GCMaterialRoutes from '@/features/GCMaterials/routes'
import eccnRoutes from '@/features/eccn/routes'
import alRoutes from '@/features/al/routes'
import zzz6Routes from '@/features/zzz6/routes'
import materialRFQRoutes from '@/features/materialRFQ/routes'

import AuthMiddleware from '../middlewares/AuthMiddleware'

import { ContributorGroupType } from '@/features/contributorGroups/constants'
import { UserEditRight, UserRole } from '@/features/users/constants'
import { Outlet } from 'react-router-dom'

const adminRoutes = [
  {
    breadcrumb: 'Admin',
    path: 'admin',

    children: [
      {
        path: 'customers',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.CUSTOMER]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: customerRoutes,
      },

      {
        path: 'contributorGroups',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: contributorGroupRoutes,
      },
      {
        path: 'frameAgreements',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: frameAgreementRoutes,
      },
      {
        path: 'GCMaterials',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA, UserEditRight.GC]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: GCMaterialRoutes,
      },
      {
        path: 'eccn',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA, UserEditRight.GC]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: eccnRoutes,
      },
      {
        path: 'al',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA, UserEditRight.GC]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: alRoutes,
      },
      {
        path: 'zzz6',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA, UserEditRight.GC]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: zzz6Routes,
      },
      {
        path: 'gc',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA, UserEditRight.GC]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: hsCodeRoutes,
      },
      {
        path: 'systemVariables',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: systemVariableRoutes,
      },
      { path: 'costCenters', children: costCenterRoutes },
      {
        path: 'gckCodes',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: gckCodeRoutes,
      },
      {
        path: 'delegations',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: delegationRoutes,
      },
      {
        path: 'documentTemplates',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: documentTemplateRoutes,
      },
      {
        path: 'rules',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: ruleRoutes,
      },
      {
        path: 'configs',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: configRoutes,
      },
      {
        path: 'applicationTypes',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: applicationTypeRoutes,
      },
      {
        path: 'SLAs',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: SLARoutes,
      },
      {
        path: 'tableProfiles',
        element: (
          <AuthMiddleware userRoles={[UserRole.ADMIN]} userRights={[UserEditRight.MASTER_DATA]}>
            <Outlet />
          </AuthMiddleware>
        ),
        children: tableProfileRoutes,
      },
      {
        path: 'vendors',
        element: (
          <AuthMiddleware
            userRoles={[UserRole.ADMIN]}
            userRights={[UserEditRight.MASTER_DATA, UserEditRight.WORKFLOW]}
            contributorGroups={[ContributorGroupType.PROCUREMENT_OFFICER]}
          >
            <Outlet />
          </AuthMiddleware>
        ),
        children: vendorAdminRoutes,
      },

      ...(config.allowMaterialRFQ
        ? [
            {
              path: 'materialRFQ',
              element: (
                <AuthMiddleware
                  userRoles={[UserRole.ADMIN]}
                  userRights={[UserEditRight.MASTER_DATA, UserEditRight.WORKFLOW]}
                  contributorGroups={[ContributorGroupType.PROCUREMENT_OFFICER]}
                >
                  <Outlet />
                </AuthMiddleware>
              ),
              children: materialRFQRoutes,
            },
          ]
        : []),
      {
        path: 'users',
        element: (
          <AuthMiddleware
            userRoles={[UserRole.ADMIN]}
            userRights={[UserEditRight.USER]}
            contributorGroups={[ContributorGroupType.PROCUREMENT_OFFICER]}
          >
            <Outlet />
          </AuthMiddleware>
        ),
        children: adminUserRoutes,
      },
    ],
  },
]

export default adminRoutes
